import { useEffect, useState } from "react";
import { useFormikContext } from "formik";
import { useFormData } from "../../../contexts/FormData";

import { Grid} from "@mui/material";

import AutoCompleteSoloFormik from "../../../utils/FormikFields/AutoCompleteSolo";

import { InputLabel } from "../../../utils/Common";

import { isEmpty } from "lodash";

const SelectWigBrand = () => {
  const { values, setValues } = useFormikContext();

  const { formValues, setFormValues } = useFormData() || {};

  const [serverOptions, setServerOptions] = useState(null);

  useEffect(() => {
    if (values?.inventory_id) return;
    let ii = formValues?.inventory_item || {};
    if (isEmpty(ii)) {
      setServerOptions([]);
    } else {
      setServerOptions([{brand_name: ii?.brand_name, vendor_id: ii?.vendor_id}]);
    }
  }, [formValues?.inventory_item, values?.inventory_id]);

  return (
    <>
      <Grid size={{xs: 12}}>
        <InputLabel>Select Wig Brand</InputLabel>
        <AutoCompleteSoloFormik 
          name="brand_name" 
          url="vendors/brands" 
          fieldName="brand_name" 
          displayField="brand_name"
          formUpdates={[{name: "vendor_id", field: "vendor_id"}]} 
          serverOptions={serverOptions}
          disabled={!!formValues?.inventory_item}
        />
      </Grid>
    </>
  )
};

export default SelectWigBrand;